import React from 'react';
import { ArrowUpRight, type LucideIcon } from 'lucide-react';

export const MetricTile: React.FC<{
  label: string;
  value: string;
  footnote?: string;
  icon: LucideIcon;
  accent: 'green' | 'blue';
  onClick: () => void;
}> = ({ label, value, footnote, icon: Icon, accent, onClick }) => {
  const border = accent === 'green' ? 'border-l-[var(--primary)]' : 'border-l-[var(--mymoolah-blue)]';
  const iconWrap = accent === 'green'
    ? 'bg-[#86BE41]/10 text-[var(--primary)]'
    : 'bg-[#2D8CCA]/10 text-[var(--mymoolah-blue)]';

  return (
    <button type="button" onClick={onClick} className={`portal-kpi-card group ${border}`}>
      <div className="mb-3 flex items-start justify-between gap-3">
        <span className="portal-kpi-card__label">{label}</span>
        <div className="flex shrink-0 items-center gap-1">
          <div className={`portal-kpi-card__icon-wrap ${iconWrap}`}>
            <Icon className="h-5 w-5" aria-hidden />
          </div>
          <ArrowUpRight
            className="h-4 w-4 text-[var(--muted-foreground)] opacity-0 transition group-hover:opacity-100"
            aria-hidden
          />
        </div>
      </div>
      <div className="portal-kpi-metrics">
        <div className="portal-kpi-metric-row">
          <span className="portal-kpi-value">{value}</span>
        </div>
      </div>
      {footnote ? <p className="portal-kpi-footnote">{footnote}</p> : null}
    </button>
  );
};
